import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconNumberOfKeys: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="number-of-keys">
    <path d="M11.4 13.4h4.2v1.2h-4.2v-1.2ZM15.1 16.4h-3.2v1.2h3.2v-1.2Z" />
    <path
      fillRule="evenodd"
      d="M11 10V4.5a2.5 2.5 0 0 1 5 0V10a3 3 0 0 1 3 3v4a5 5 0 0 1-5 5h-1a5 5 0 0 1-5-5v-4a3 3 0 0 1 3-3Zm3.8-5.5V10h-2.6V4.5a1.3 1.3 0 1 1 2.6 0ZM11 11.2A1.8 1.8 0 0 0 9.2 13v4a3.8 3.8 0 0 0 3.8 3.8h1a3.8 3.8 0 0 0 3.8-3.8v-4a1.8 1.8 0 0 0-1.8-1.8h-5Z"
      clipRule="evenodd"
    />
    <path d="M7 11.6A1.4 1.4 0 0 0 5.6 13v4.307c0 1.381.84 2.623 2.123 3.136l-.446 1.114a4.577 4.577 0 0 1-2.877-4.25V13A2.6 2.6 0 0 1 7 10.4v1.2ZM8.6 3a.6.6 0 0 0-1.2 0v6.6h1.2V3Z" />
  </Icon>
);
